import React, { memo } from 'react';

const NextActionCellRendererComponent = ({ data, value }) => {
  if (!data) return <span />;

  if (value) {
    return data.backlogged ? (
      <span>
        <i className="fa fa-clock-o" /> {value}
      </span>
    ) : (
      <span>{value}</span>
    );
  }

  return <span />;
};

export const NextActionCellRenderer = memo(NextActionCellRendererComponent);
